import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

export default function Submitted() {
  const navigate = useNavigate();
  const [student, setStudent] = useState(null);

  useEffect(() => {
    const stored = sessionStorage.getItem("student");
    const submitted = sessionStorage.getItem("submitted");
    if (!stored || !submitted) { navigate("/"); return; }
    setStudent(JSON.parse(stored));
    sessionStorage.removeItem("submitted");
  }, [navigate]);

  return (
    <div className="page-wrapper">
      <Header subtitle="Assessment Portal" />
      <div className="submitted-wrap">
        <div className="success-icon">✅</div>
        <h1 style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 800, fontSize: "2rem", background: "linear-gradient(135deg,#10b981,#00d4ff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", marginBottom: 12 }}>
          Submitted!
        </h1>
        <p style={{ color: "var(--muted)", fontSize: "1rem", lineHeight: 1.7, marginBottom: 28 }}>
          {student ? `Thank you, ${student.name}!` : "Thank you!"} Your assessment has been submitted successfully. Your answers are now under review by our team.
        </p>
        <div className="glass-card" style={{ textAlign: "left", marginBottom: 24 }}>
          <h3 style={{ fontFamily: "'Poppins',sans-serif", fontSize: "0.85rem", letterSpacing: "1.5px", textTransform: "uppercase", color: "var(--accent)", marginBottom: 16 }}>Your Details</h3>
          {student && (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[{ label: "Name", value: student.name }, { label: "Mobile", value: student.mobile }, { label: "Email", value: student.email }].map(item => (
                <div key={item.label} style={{ display: "flex", justifyContent: "space-between", fontSize: "0.9rem" }}>
                  <span style={{ color: "var(--muted)" }}>{item.label}</span>
                  <span style={{ fontWeight: 500 }}>{item.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div style={{ padding: "16px 20px", background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)", borderRadius: 14, fontSize: "0.85rem", color: "var(--gold)", lineHeight: 1.6 }}>
          ℹ️ Your marks will be reviewed and assigned by our admin team. Results will be communicated to you separately.
        </div>
        <div style={{ marginTop: 24 }}>
          <button className="btn-primary" style={{ width: "auto", padding: "12px 28px" }} onClick={() => { sessionStorage.clear(); navigate("/"); }}>Return to Home</button>
        </div>
      </div>
    </div>
  );
}